import React from 'react';
import { Navigate } from 'react-router-dom';
import { PROFILE_TYPE } from '../../helper/globalConstant';

const withAdminPlatform = <P extends object>(WrappedComponent: React.ComponentType<P>) => {

  return (props: P) => {
    const sess_user_data = localStorage.getItem('sess_user');

    if (sess_user_data) {

      const sess_user = JSON.parse(sess_user_data);

      const priority = sess_user?.userProfile?.priority;

      if (priority === PROFILE_TYPE.SUPER_ADMIN) return <WrappedComponent {...props} />;

      return <Navigate to="/customer/overview" replace />;

    }


    return <Navigate to="/login" replace />;
  };
};

export default withAdminPlatform;
